import React, { useMemo, useState } from 'react'
import { useGlobalFilter, usePagination, HeaderGroup, Accessor, useSortBy, useTable, useRowSelect } from 'react-table'
import ComponentePaginacionTabla from 'components/Varios/Tabla/ComponentePaginacionTabla';
import { GlobalFilterTable } from 'components/Varios/Tabla/GlobalFilterTable';
import ButtonDownloadReportTable from "components/Varios/Tabla/ComponentButtonExcel"
import { Container, Row, Col, Button } from 'reactstrap';
import { ObtenerFechaFromIsoFormat } from 'functions/DatesFunctions';
import { Table } from 'reactstrap'
import { getTdTableStyles } from 'helpers/Table/tableFunctions';
import config from "config.json";
import { CustomStyleColumn } from 'components/Types/GeneralTypes';
import { Checkbox } from 'components/Varios/Tabla/CheckBoxTable';
import { downloadExcelReport } from './FunctionComunicadoSolicitudesV';

import PdfSVG from "assets/icons/Permisos/PDF(azul).svg"
import AnularSVG from "assets/icons/Permisos/anularXazul.svg"
import AprobarSVG from "assets/icons/Permisos/Visto.svg"
import RechazoPSVG from "assets/icons/Permisos/Regresar.svg"

import ButtonAprobarMasivo from 'components/Varios/ButtonAprobarMasivo';

export default function TablaComunicadoSolicitudesV({ dataFilas, onClickVerDocumento, onClickComunicar, onClickNotificacionMasiva, onClickRechazar }) {
    const filas = useMemo(
        () => [...dataFilas], [dataFilas]
    )

    function GenerarCellDocumentos(data) {
        const iconoDescargarSolicitud = (
            <i
                data-toggle="tooltip" data-placement="top" title="Vista Previa Solicitud"
                onClick={() => onClickVerDocumento(data.documentos.refDoc)}
            >
                <img
                    src={PdfSVG} // Cambia la ruta al lugar donde esté almacenado tu SVG
                    className="acciones"
                    alt="Vista Previa Solicitud"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Vista Previa Solicitud"
                    style={{ width: 24, height: 24 }} // Ajusta el tamaño según necesites
                />
            </i>
        )

        const contentAccion = (
            <React.Fragment>
                {data.documentos.refDoc && iconoDescargarSolicitud}
            </React.Fragment>
        )
        return contentAccion
    }

    function GenerarCellAcciones(data) {
        const iconoNotificarSolicitud = (
            <i
                data-toggle="tooltip" data-placement="top" title="Notificar Solicitud"
                onClick={() => onClickComunicar(data.acciones)}
            >
                <img
                    src={AprobarSVG} // Cambia la ruta al lugar donde esté almacenado tu SVG
                    className="acciones"
                    alt="Notificar Solicitud"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Notificar Solicitud"
                    style={{ width: 24, height: 24 }} // Ajusta el tamaño según necesites
                />
            </i>
        )

        const iconoAnularSolicitud = (
            <i
                data-toggle="tooltip" data-placement="top" title="Rechazo Acción Personal"
                onClick={() => onClickRechazar(data.acciones)}
            >
                <img
                    src={AnularSVG} // Cambia la ruta al lugar donde esté almacenado tu SVG
                    className="acciones"
                    alt="Rechazo Acción Personal"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Rechazo Acción Personal"
                    style={{ width: 24, height: 24 }} // Ajusta el tamaño según necesites
                />
            </i>
        )

        const contentAccion = (
            <React.Fragment>
                {iconoNotificarSolicitud}
                {iconoAnularSolicitud}
            </React.Fragment>
        )
        return contentAccion
    }

    const columnas = React.useMemo(
        () => [
            {
                Header: 'Fecha Solicitud',
                accessor: 'fechaSolicitud',
                Cell: ({ value }) => ObtenerFechaFromIsoFormat(value)
            },
            {
                Header: "Tipo de Solicitud",
                accessor: "tipoSolicitud"
            },
            {
                Header: 'Nombres',
                accessor: 'nombres',
            },
            {
                Header: 'Régimen',
                accessor: 'siglasRegimen',
            },
            {
                Header: 'Grado',
                accessor: 'grado',
            },
            {
                Header: 'RMU',
                accessor: 'rmu',
            },
            {
                Header: '# Partida',
                accessor: 'numeroPartida',
            },
            {
                Header: 'Fechas',
                id: 'fechas',
                accessor: row => ({
                    fechaInicio: row.fechaInicio,
                    fechaFin: row.fechaFin
                }),
                Cell: ({ value }) => {
                    const fechaDesde = ObtenerFechaFromIsoFormat(value.fechaInicio);
                    const fechaHasta = ObtenerFechaFromIsoFormat(value.fechaFin);
                    return (
                        <>
                            <div><strong>Desde: </strong>{fechaDesde}</div>
                            <div><strong>Hasta: </strong>{fechaHasta}</div>
                        </>
                    );
                }
            },
            {
                Header: '# Días',
                accessor: 'tiempo',
            },
            {
                Header: 'Observaciones',
                accessor: 'observacion',
            },
            {
                Header: "Documentos",
                accessor: (row) => ({
                    documentos: row,
                }),
                Cell: ({ value }) => GenerarCellDocumentos(value)
            },
            {
                Header: "Acciones",
                accessor: (row) => ({
                    acciones: row,
                }),
                Cell: ({ value }) => GenerarCellAcciones(value)
            },
        ], [dataFilas])

    const columnasStyles = (cell) => [
        {
            HeaderName: "Estado Solicitud",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: 'Acciones',
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: 'Documentos',
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "Semanas",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "Fecha Unidad",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "Fecha Solicitud",
            StyleHeader: {
                textAlign: "center"
            }
        }
        ,
        {
            HeaderName: "Fechas",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "# Días",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "Régimen",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "Grado",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "RMU",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "# Partida",
            StyleHeader: {
                textAlign: "center"
            }
        }
    ]

    function ShowCheckBoxCondition(dataRow) {
        return true;
    }

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        nextPage,
        previousPage,
        canNextPage,
        canPreviousPage,
        pageOptions,
        setPageSize,
        selectedFlatRows,
        visibleColumns,
        prepareRow,
        state,
        setGlobalFilter
    } = useTable(
        {
            columns: columnas,
            data: filas
        },
        useGlobalFilter,
        useSortBy,
        usePagination,
        useRowSelect,
        (hooks) => {
            hooks.visibleColumns.push((columns) => {
                return [

                    ...columns,
                    {
                        id: 'selection',
                        Header: ({ getToggleAllPageRowsSelectedProps }) => (
                            <Checkbox
                                isHeader={true}
                                {...getToggleAllPageRowsSelectedProps()}
                            />
                        ),
                        Cell: ({ row }) => (
                            <Checkbox
                                condition={ShowCheckBoxCondition(row.values)}
                                {...row.getToggleRowSelectedProps()}

                            />
                        )

                    }
                ]
            })
        }
        )

    const { globalFilter, pageIndex, pageSize } = state;
    const sizerows = filas.length;

    const ButtonNotificacionMasiva = useMemo(() => {

        const nombreBotonNotificarMasivo = "Notificar todas las acciones de personal seleccionadas";
        if (selectedFlatRows.length === 1) {
            var filaSeleccionada = selectedFlatRows[0].original;
            return <ButtonAprobarMasivo
                onClick={() => onClickComunicar(filaSeleccionada)}
                text="Notificar Acción de Personal"
            />
        }
        else if (selectedFlatRows.length > 1) {
            var filasSeleccionadas = selectedFlatRows;
            var filasMapeadas = [];
            filasSeleccionadas.forEach(element => {
                filasMapeadas.push(element.original);
            });
            if (filasSeleccionadas.length > 1) {
                return <ButtonAprobarMasivo
                    onClick={() => onClickNotificacionMasiva(filasMapeadas)}
                    text={nombreBotonNotificarMasivo}
                />
            }
            else if (filasSeleccionadas.length < 0) {
                return <ButtonAprobarMasivo
                    disabled
                    text="Notificar Acción de Personal"
                />
            }
        }
        else {
            return <ButtonAprobarMasivo
                disabled
                text="Notificar Acción de Personal"
            />
        }
    }, [selectedFlatRows])

    return (
        <React.Fragment>
            <Row>
                <Col xl={12}>
                    <div className="containerBtnAprobacionesVacLic">
                        <GlobalFilterTable
                            filter={globalFilter}
                            setFilter={setGlobalFilter}
                        />
                        <div className='containerBotonGenerarReporte'>
                            <ButtonAprobarMasivo
                                onClick={() => downloadExcelReport()}
                                text="GENERAR REPORTE"
                            />
                        </div>
                        {ButtonNotificacionMasiva}
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xl={12}>
                    <Table responsive {...getTableProps()} style={{ border: 'solid 1px ' }} className="tablesReact" >
                        <thead style={{}}>
                            {headerGroups.map(headerGroup => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map(column => (
                                        <th
                                            {...column.getHeaderProps(column.getSortByToggleProps())}
                                            className='clickable'
                                        >
                                            {column.render('Header')}
                                            <span>
                                                {column.isSorted ? (column.isSortedDesc ? '⬆️' : '⬇️') : ''}
                                            </span>
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {page.map((row, indirow) => {
                                prepareRow(row)
                                return (
                                    <tr {...row.getRowProps()}>

                                        {row.cells.map(cell => {
                                            return getTdTableStyles(cell, { border: 'solid 1px black' }, indirow, columnasStyles(cell))

                                        })}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </Table>
                    <ComponentePaginacionTabla
                        page={page}
                        sizerows={sizerows}
                        canNextPage={canNextPage}
                        canPreviousPage={canPreviousPage}
                        nextPage={nextPage}
                        pageIndex={pageIndex}
                        pageOptions={pageOptions}
                        pageSize={pageSize}
                        previousPage={previousPage}
                        setPageSize={setPageSize}
                    />
                </Col>
            </Row>
        </React.Fragment>
    )
}